import React from 'react'
import Navbar from '../../components/Navbar'
import Sidebar from '../../components/Sidebar'
import LogsReportComponent from '../../components/LogsReportComponent/LogsReportComponent'

const LogsReport = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <LogsReportComponent/>
                </div>
            </div>
        </div>
    )
}

export default LogsReport
